import { render, staticRenderFns } from "./Wishlists.vue?vue&type=template&id=55f6067d&scoped=true&"
import script from "./Wishlists.vue?vue&type=script&lang=js&"
export * from "./Wishlists.vue?vue&type=script&lang=js&"
import style0 from "./Wishlists.vue?vue&type=style&index=0&id=55f6067d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f6067d",
  null
  
)

export default component.exports